export const url_minha_box = {
	Dev: 'dev-app.farme.com.br/minha-box',
	Staging: 'staging-app.farme.com.br/minha-box',
	Prod: 'app.farme.com.br/minha-box',
	Local: 'dev-app.farme.com.br/minha-box'
};
